import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, Heading, ChipContext } from '@warrenbrasil/nebraska-web';
import { ProgressiveImage } from '@/modules/common/components/ProgressiveImage';

interface EmitEvents {
  (event: 'click'): void;
}
interface Props {
  image: string;
  head: string;
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectiveCard',
  props: {
    image: null,
    head: null,
    title: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  image: string;
  head: string;
  title: string;
};





const hasHover = ref(false);

const hasImage = computed(() => {
  return !!props.image;
});

function handleEnter() {
  hasHover.value = true;
}

function handleLeave() {
  hasHover.value = false;
}

function emitClick() {
  emit('click');
}

return { __sfc: true,emit, props, hasHover, hasImage, handleEnter, handleLeave, emitClick, NebraskaColors, BaseText, Heading, ChipContext, ProgressiveImage }
}

})